import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { ComponentDataSourceService } from '../component-data-source.service';
import { DualPanelItem } from '../../../interfaces/DualPanelItem.interface';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { EducationalPathDTO } from '../../../dto/educational-path/educational-path.dto';
import { environment } from '../../../environment/environment';

interface User {
    user_id: number;
    first_name: string;
    last_name: string;
    email: string;
}

export function dual_panel_unassigned_users(componentDataSourceService: ComponentDataSourceService) {
    let lastPathGuid: string | null = null;
    
    return {
        name: 'Unassigned Users',
        description: 'Lists all unassigned users',
        execute: () => {
            
            // Get current path GUID
            const currentGuid = componentDataSourceService.getCurrentSlug();
            
            // If the GUID has changed, clear the cached data
            if (currentGuid !== lastPathGuid) {
                componentDataSourceService.clearEducationalPathData();
                lastPathGuid = currentGuid;
            }

            // Get all users and the educational path's assigned users
            return componentDataSourceService.http.get<{ items: User[] }>(`${environment.apiUrl}/users`).pipe(
                catchError(error => {
                    console.error('Error fetching users:', error);
                    return of({ items: [] });
                }),
                switchMap(usersResponse => {
                    const allUsers = usersResponse.items || [];
                    // Get the educational path to find assigned users
                    return componentDataSourceService.getEducationalPathData().pipe(
                        catchError(error => {
                            console.error('Error fetching educational path:', error);
                            return of(null);
                        }),
                        map(pathResult => {
                            const assignedUserIds = new Set(
                                pathResult?.assigned_users?.map((user: any) => user.user_id) || []
                            );

                            
                            // Check specifically for Mikkel
                            const mikkelInAllUsers = allUsers.find(user => 
                                user.first_name?.toLowerCase().includes('mikkel') || 
                                user.last_name?.toLowerCase().includes('mikkel')
                            );
                            const mikkelInAssigned = pathResult?.assigned_users?.find((user: any) => 
                                user.first_name?.toLowerCase().includes('mikkel') || 
                                user.last_name?.toLowerCase().includes('mikkel')
                            );
                            

                            // Filter out already assigned users
                            const unassignedUsers = allUsers.filter(user => {
                                const isAssigned = assignedUserIds.has(user.user_id);
                                if (user.first_name?.toLowerCase().includes('mikkel') || user.last_name?.toLowerCase().includes('mikkel')) {
                                }
                                return !isAssigned;
                            });

                            // Sort unassigned users by full name (first_name + last_name)
                            const sortedUnassigned = [...unassignedUsers].sort((a, b) => {
                                const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
                                const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
                                return nameA.localeCompare(nameB);
                            });

                            // Convert to DualPanelItem format
                            const items: DualPanelItem[] = sortedUnassigned.map(user => ({
                                value: user.user_id,
                                name: `${user.first_name} ${user.last_name}`,
                                type: user.email
                            }));

                            return {
                                data: items
                            };
                        })
                    );
                })
            );
        }
    };
} 